var _mask, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 1008,
    viewBox: "0 0 252 1008",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_123_3357",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 252,
    height: 1008
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_123_3357",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H252V1008H0V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H252V1008H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251 0V1008H253V0H251ZM1 1008V0H-1V1008H1Z",
    fill: "#DFDFDF",
    mask: "url(#path-1-inside-1_123_3357)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_123_3357)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_123_3357)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80.1538,
    y: -78.8398,
    width: 83.3538,
    height: 1135.24,
    fill: "#E0E0E0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_123_3357",
    x: -120.154,
    y: -118.84,
    width: 163.354,
    height: 1215.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_123_3357"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShadow);
export default __webpack_public_path__ + "static/media/bg-shadow.4710e3845127d54038a87710802d6a00.svg";
export { ForwardRef as ReactComponent };